import { z } from 'zod';
// --- Request Schemas ---
export const CreateChatSchema = z.object({});
export const ChatIdParamSchema = z.object({
    chatId: z.string().uuid(),
});
export const SendChatMessageSchema = z.object({
    content: z.string().min(1).max(2000),
});
// --- Settings Schema ---
export const ChatSettingsSchema = z.object({
    enabled: z.boolean().optional(),
});
export const ChatMessageSchema = z.object({
    role: z.enum(['system', 'user', 'assistant', 'tool']),
    content: z.string().nullable(),
    tool_calls: z
        .array(z.object({
        id: z.string(),
        function: z.object({
            name: z.string(),
            arguments: z.string(),
        }),
    }))
        .optional(),
    tool_call_id: z.string().optional(),
    timestamp: z.string(),
});
//# sourceMappingURL=chat.schema.js.map